/**
 * @file
 * Toggle header on mobiles.
 *
 */

(($, Drupal) => {
  Drupal.behaviors.header_toggle = {
    attach: (/* context, settings */) => {
      // Open overlay menu
      $(".header__menu-toggle").click(() => {
        $(".header").addClass("is-active");
      });
      // Close overlay menu
      $(".header__close").click(() => {
        $(".header").removeClass("is-active");
      });
      // Close mobile menu on overlay
      $(".header__blur-bg").click(() => {
        $(".header").removeClass("is-active");
      });
      // Close on outside click
      // $(document).on("click", (e) => {
      //   if (
      //     $(e.target).is(".header__overlay, .header__menu-toggle") === false
      //   ) {
      //     $(".header").removeClass("is-active");
      //   }
      // });
    },
  };
})(jQuery, Drupal);
